/// <amd-module name="Environments/CreatePanel/Actions/EnvironmentsCreatePanelActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { EnvironmentInstance } from "DistributedTask/Client/Contracts/TaskAgent";

export class EnvironmentsCreatePanelActions extends ActionsHubBase {

    public static getKey(): string {
        return "environments-create-panel-actions";
    }

    public initialize(instanceId?: string) {
        this._createEnvironment = new Action<EnvironmentInstance>();
    }

    public get createEnvironment(): Action<EnvironmentInstance> {
        return this._createEnvironment;
    }

    private _createEnvironment: Action<EnvironmentInstance>;
}
